import { Plan } from './../app/models/Plan';

export const FREE_PLAN = '8e291031-457d-11ec-9f39-0242c0a80303';
export const FUNNEL_GOLD = '';

/**
 * Checkout externo da assinatura (AzPague). Não existe tela de planos no painel:
 * todo convite a assinar (banner da home, dica da carteira, `app-plan-message`)
 * aponta para cá, com o id do usuário como referência.
 */
export const PLANS_CHECKOUT_URL = 'https://azpague.com.br/cart/U9s6Jx';

export function plansCheckoutUrl(userId: string | undefined | null): string {
  return userId ? `${PLANS_CHECKOUT_URL}?ref=${userId}` : PLANS_CHECKOUT_URL;
}

const plans: Plan[] = [{
  id: FREE_PLAN,
  name: 'Grátis para Testar'
}, {
  id: FUNNEL_GOLD,
  name: 'Funnel Gold'
}];

export default plans;
